import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

interface OnboardingErrorContextValue {
  error: Error | null;
  reportError: (error: Error | null) => void;
}

const OnboardingErrorContext =
  createContext<OnboardingErrorContextValue | null>(null);

export const OnboardingErrorProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [error, setError] = useState<Error | null>(null);

  const value = useMemo<OnboardingErrorContextValue>(
    () => ({ error, reportError: setError }),
    [error],
  );

  return (
    <OnboardingErrorContext.Provider value={value}>
      {children}
    </OnboardingErrorContext.Provider>
  );
};

export const useOnboardingError = () => {
  const ctx = useContext(OnboardingErrorContext);
  if (!ctx) {
    throw new Error(
      'useOnboardingError must be used within <OnboardingErrorProvider>',
    );
  }
  return ctx;
};
